import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import { Banner } from 'foundations-components/transitional/components/Banner';
import { useGetKnowledgeBaseLimitOverage } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import { selectHasAccessToMultiKB } from '../../knowledge-base/selectors/selectHasAccessToMultiKB';
import { getSettingUrl } from '../../routing/utils/externalUrls';
import { getLimits } from '../../selectors/auth';
import { useAppSelector } from '../../utils/hooks';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpgradeDowngradeBanner = ({
  currentArticleCount
}) => {
  const hasAccessToMultiKB = useAppSelector(selectHasAccessToMultiKB);
  const {
    isOverLimit,
    overageCount
  } = useGetKnowledgeBaseLimitOverage();
  const articlesLimit = useAppSelector(state => getLimits(state)['knowledge-articles'] || 2000);
  if (isOverLimit) {
    return /*#__PURE__*/_jsxs(Banner, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.downgradeBanner.title"
      }),
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.downgradeBanner.description_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: getSettingUrl(),
            use: 'on-dark',
            count: overageCount
          }
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "knowledgeContentUI.downgradeBanner.downgradesLink_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: 'https://knowledge.hubspot.com/account/downgrade-a-paid-subscription',
          external: true,
          use: 'on-dark'
        }
      })]
    });
  }
  if (!hasAccessToMultiKB) {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(UIUpgradeBanner, {
        upgradeKey: "knowledge-base-article-limit-index",
        value: currentArticleCount,
        limit: articlesLimit,
        displayThreshold: articlesLimit - 25
      })
    });
  }
  return null;
};
export default UpgradeDowngradeBanner;